// extracted by mini-css-extract-plugin
export default {"wrapper":"Bo","form":"Co","preference":"Do","request":"Eo","job":"Fo","smallprint":"Go","asterisk":"Ho","success":"Io","circle":"Jo"};